 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import LOVE_1 from '@/components/love_1'
 import TEXTTITLE from '@/components/Text/title'
 import TEXTTOC from '@/components/Text/toc'
 import TEXTDEDT from '@/components/Text/dedt'
 import TEXTACK from '@/components/Text/ack'
 import TEXTEPI from '@/components/Text/epi'
 import TEXTCHAP1 from '@/components/Text/chap1'
 import TEXTCHAP2 from '@/components/Text/chap2'
 import TEXTCHAP3 from '@/components/Text/chap3'
 import TEXTCHAP4 from '@/components/Text/chap4'
 import TEXTCHAP5 from '@/components/Text/chap5'
 import TEXTCHAP6 from '@/components/Text/chap6'
 import TEXTCHAP7 from '@/components/Text/chap7'
 import TEXTCHAP8 from '@/components/Text/chap8'
 import TEXTCHAP9 from '@/components/Text/chap9'
 import TEXTCHAP10 from '@/components/Text/chap10'
 import TEXTCHAP11 from '@/components/Text/chap11'
 import TEXTCHAP12 from '@/components/Text/chap12'
 import TEXTCHAP13 from '@/components/Text/chap13'
 import TEXTCHAP14 from '@/components/Text/chap14'
 import TEXTCHAP15 from '@/components/Text/chap15'
 import TEXTCHAP16 from '@/components/Text/chap16'
 import TEXTCHAP17 from '@/components/Text/chap17'
 import TEXTCHAP18 from '@/components/Text/chap18'
 import TEXTCHAP19 from '@/components/Text/chap19'
 import TEXTCHAP20 from '@/components/Text/chap20'
 import TEXTPART2 from '@/components/Text/part2'
 import TEXTCHAP21 from '@/components/Text/chap21'
 import TEXTCHAP22 from '@/components/Text/chap22'
 import TEXTCHAP23 from '@/components/Text/chap23'
 import TEXTCHAP24 from '@/components/Text/chap24'
 import TEXTCHAP25 from '@/components/Text/chap25'
 import TEXTCHAP26 from '@/components/Text/chap26'
 import TEXTCHAP27 from '@/components/Text/chap27'
 import TEXTCHAP28 from '@/components/Text/chap28'
 import TEXTCHAP29 from '@/components/Text/chap29'
 import TEXTRGG from '@/components/Text/rgg'
 import TEXTBIO from '@/components/Text/bio'
 import TEXTANNA from '@/components/Text/anna'
 import TEXTBOUND from '@/components/Text/bound'
 import LOVE_2 from '@/components/love_2'
 import TEXTCOPY from '@/components/Text/copy'
 import TEXTAKB from '@/components/Text/akb'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/toc",
 			"name" : "Text/toc",
 			"component" : TEXTTOC
 		},
 		{
 			"path" : "/Text/dedt",
 			"name" : "Text/dedt",
 			"component" : TEXTDEDT
 		},
 		{
 			"path" : "/Text/ack",
 			"name" : "Text/ack",
 			"component" : TEXTACK
 		},
 		{
 			"path" : "/Text/epi",
 			"name" : "Text/epi",
 			"component" : TEXTEPI
 		},
 		{
 			"path" : "/Text/chap1",
 			"name" : "Text/chap1",
 			"component" : TEXTCHAP1
 		},
 		{
 			"path" : "/Text/chap2",
 			"name" : "Text/chap2",
 			"component" : TEXTCHAP2
 		},
 		{
 			"path" : "/Text/chap3",
 			"name" : "Text/chap3",
 			"component" : TEXTCHAP3
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js